module.exports = {"430424100":"洣水镇","430424101":"石湾镇","430424102":"新塘镇","430424103":"大浦镇","430424104":"吴集镇","430424105":"甘溪镇","430424106":"杨林镇","430424107":"草市镇","430424108":"杨桥镇","430424109":"霞流镇","430424110":"荣桓镇","430424111":"高湖镇","430424112":"白莲镇","430424113":"三樟镇","430424114":"蓬源镇","430424204":"南湾乡","430424211":"石滩乡","430424401":"河西开发区","430424403":"大浦工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430424.json
// module id = 1683
// module chunks = 0